<template>
  <div class="about-layout">
    <router-view />
  </div>
</template>

<script setup>

</script>